
import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IItems } from '../form.interface';

/**
 * 获取table-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getTableDisabledItems = (model: ITableModel): IItems => ({
    [FormItemName.LAYOUT_ROTATE]: () => true,
    [FormItemName.SIZE_ADJUST]: () => true,
});
